import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@saucelabs/ds-button';
import { IconLiveTimeOutline } from '@saucelabs/ds-icons';
import { modalActions } from '@saucelabs/sl-container-modal';

import constants from '../constants';
import {
  EVENTS,
  LIVE_TESTING_TRACKING_PROPS,
  LIVE_TESTING_PRODUCT_SUB_AREAS,
  LIVE_TESTING_SUBJECT_NAMES,
  trackEvent,
} from '../../../tracking';

const trackButtonClick = () => trackEvent(EVENTS.OBJECT_CLICKED, {
  subject_name: LIVE_TESTING_SUBJECT_NAMES.RECENTS_BUTTON_CLICKED,
  product_sub_area: LIVE_TESTING_PRODUCT_SUB_AREAS.RECENTS,
  ...LIVE_TESTING_TRACKING_PROPS,
});

const ShowRecentsButton: React.FC = () => {
  const dispatch = useDispatch();

  return (
    <Button
      className="ml-auto mr-2"
      data-intercom="show-recents-button"
      data-qa="presets-show-recents-button"
      onPress={() => {
        dispatch(modalActions.showModal(constants.RECENTS_MODAL_IDENTIFIER));
        trackButtonClick();
      }}
      prefixIcon={<IconLiveTimeOutline />}
      variant="outline"
    >
      Recents
    </Button>
  );
};

export default ShowRecentsButton;
